import DashboardSectionHeader from './DashboardSectionHeader';

export default DashboardSectionHeader;
